<template>
	<!-- 悬浮切换按钮 -->
	<div class="all_flex_box"></div>
</template>
<script>
export default {
	props: {
		id: {
			type: Number,
			required: true,
		},
		indexs: {
			type: String,
			required: true,
		},
		gameType: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {};
	},
	methods: {
		choseone(e) {
			let indexs = e.target.dataset.index;
			let ids = e.target.dataset.id;
			this.$router.push({
				path: "/gamePanel",
				params: {
					id: ids,
					index: indexs,
				},
			});
		},
	},
};
</script>
<style lang="scss">
.all_flex_box {
	position: absolute;
	top: 152px;
	left: -63px;

	a {
		display: block;
		width: 56px;
		height: 50px;
		text-align: center;
		margin-bottom: 10px;
		color: #ffffff;
		border-radius: 5px;
		font-size: 12px;
		padding: 5px 15px;
		cursor: pointer;
	}
}

.all_flex_box .all_choice_tabbtn {
	background-color: #1f7877;
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/flex_tab.vue